import { BaseRouteService } from 'core/services';

class FacilityOrderPatientRouteService extends BaseRouteService {
    constructor() {
        super('facility-order-patients');
    }
   
    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,facilityOrderId,patientId}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }
    
    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }	
    
    setIsNoteReviewed(resource) {
		return super.update(`${this.base}/set-note-reviewed/{?id}`, resource);	
	}

    updateNote(resource){
		return super.update(`${this.base}/{id}/update-note`, resource);	
	}
	
    updateInsuranceQuestion(resource) {
		return super.update(`${this.base}/{id}/update-insurance-question/{?insuranceQuestion}`, resource);	
	}	
	
	resolveInsuranceQuestion(resource) {
		return super.update(`${this.base}/update-is-insurance-question/{?id}`, resource);	
	}	

    changeFacilityOrderPatientInsuranceStatus(resource) {
		return super.update(`${this.base}/{id}/change-insurance-status/{?insuranceReview}`, resource);	
	}
}

export default FacilityOrderPatientRouteService;
